import { Component, OnInit } from '@angular/core';
import { DrFileMeta, DrFileMetaList, FileUploadStatus } from '@app/shared/models/dr-file';
import { FileCategory, FileType, FileTypes } from '@app/shared/models/file-type';
import * as _ from 'lodash-es';
import { CaseFileCategories } from '@app/shared/models/case-file-category';
import { SmpUtils } from '@app/core/helpers/utilities';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';

@Component({
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent extends BaseWithBundleComponent implements OnInit {

  public panelOpenState: any;
  public panelOpenState2: any;
  public some: any;

  public fileMetaList1: DrFileMetaList;
  public fileMetaList2: DrFileMetaList;
  public acceptedFileTypes: FileType[];
  public selectedFiles: any[];

  constructor(protected componentServiceBundle: ComponentServiceBundle) {
    super(componentServiceBundle);
  }

  ngOnInit() {
    console.log('template init!');
    this.acceptedFileTypes = [];
    this.selectedFiles = new Array();
    this.fileMetaList1 = new DrFileMetaList();
    this.fileMetaList1.document_type = CaseFileCategories.ACCIDENT_DOCUMENT;;
    this.fileMetaList2 = new DrFileMetaList();
    this.fileMetaList2.document_type = CaseFileCategories.CLAIM_IMAGE;
  }

  public onFilesSelectedList(files: File[]) {

    if (files) {
      _.each(files, (file: File) => {
        const newFileMeta = new DrFileMeta(file);
        newFileMeta.id = Math.random().toString().replace('0.', '');
        newFileMeta.filename = file.name;
        newFileMeta.document_type = this.fileMetaList1.document_type;
        newFileMeta.status = FileUploadStatus.LOADING;
        newFileMeta.fileType = FileTypes.getByKey(SmpUtils.getExtensionFromFileName(file.name));
        this.fileMetaList1.addFileMetaData(newFileMeta);

        setTimeout(() => {
          newFileMeta.status = FileUploadStatus.READY;
        }, 3000);

      });
    }
  }

  public onFilesSelectedThumbnail(files: File[]) {
    if (files) {
      _.each(files, (file: File) => {
        const newFileMeta = new DrFileMeta();
        newFileMeta.id = Math.random().toString().replace('0.', '');
        newFileMeta.filename = file.name;
        newFileMeta.document_type = this.fileMetaList2.document_type;
        newFileMeta.status = FileUploadStatus.LOADING;
        newFileMeta.fileType = FileTypes.getByKey(SmpUtils.getExtensionFromFileName(file.name));
        this.fileMetaList2.addFileMetaData(newFileMeta);

        setTimeout(() => {
          newFileMeta.status = FileUploadStatus.READY;
          newFileMeta.category = FileCategory[FileCategory.PHOTO];
          newFileMeta.link = 'assets/images/car-test.jpg'; // demo picture because these demo files are not saved to the content store
        }, 3000);

      });
    }
  }

  public demo(event: any): void {
    window.alert('Hey this is only a simple demo ...');
  }

  public deleteFile1(file: DrFileMeta): void {
    this.fileMetaList1.removeFileMetaData(file);
  }

  public deleteFile2(file: DrFileMeta): void {
    this.fileMetaList2.removeFileMetaData(file);
  }

  public selectFile(file: DrFileMeta): void {
    if (this.selectedFiles.find(selected => selected.id === file.id)) {
      this.selectedFiles = this.selectedFiles.filter(selected => selected.id !== file.id);
    } else {
      this.selectedFiles.push(file);
    }
  }
}
